import * as React from 'react';
export const dhlSvg = React.forwardRef(function dhlSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFCB01',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: '#D80613',
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'm6.573 14.228-.929 1.252h5.062c.256 0 .253.096.128.265-.127.171-.34.467-.47.641-.065.088-.184.248.21.248h2.07l.613-.827c.38-.512.033-1.578-1.327-1.578H6.573z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'm5.268 18.308 1.866-2.516h2.315c.256 0 .253.096.128.265l-.473.638c-.065.088-.184.248.21.248h3.1c-.257.351-1.095 1.365-2.596 1.365h-4.55zm10.684-1.365-1.012 1.365h-2.668l1.011-1.365h2.67zm4.088-.31h-6.527l1.785-2.405h2.667l-1.022 1.38h1.19l1.024-1.38h2.667l-1.784 2.406zm-.23.31-1.01 1.365h-2.67l1.012-1.365h2.668zm-18.35.538h3.931l-.214.29H1.461v-.29zm0-.538h4.331l-.215.29H1.461v-.29zm0 1.076h3.533l-.214.289H1.46v-.289zm29.07-.249h-3.916l.215-.289h3.702v.29zm0 .538h-4.313l.213-.289h4.1v.289zm-3.302-1.365h3.303v.29h-3.517l.214-.29zm-1.71-2.715-1.784 2.406h-2.827l1.786-2.406h2.826zm-5.13 3.106c-.334.45-.038.973 1.055.973h4.285l1.011-1.364h-6.06l-.29.391z',
        }),
      ),
    ),
  );
});
dhlSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dhl = {
  category: 'brand',
  colorable: false,
  name: 'dhl',
  svg: dhlSvg,
};
